// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rm {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
}

.rm-accent-bar {
  height: 4px;
  background: linear-gradient(90deg, #6366f1 0%, #4f46e5 50%, #818cf8 100%);
  flex-shrink: 0;
}

.rm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 14px;
  flex-shrink: 0;
}
.rm-header .rm-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.rm-header .rm-icon-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(79, 70, 229, 0.1) 100%);
  color: #6366f1;
  font-size: 22px;
  flex-shrink: 0;
}
.rm-header .rm-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}
body.dark .rm-header .rm-title {
  color: #f1f5f9;
}
.rm-header .rm-subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
body.dark .rm-header .rm-subtitle {
  color: #94a3b8;
}
.rm-header .rm-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: rgba(241, 245, 249, 0.8);
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 18px;
  flex-shrink: 0;
}
.rm-header .rm-close:hover {
  background: rgba(226, 232, 240, 0.8);
  color: #1e293b;
}
body.dark .rm-header .rm-close {
  background: rgba(51, 65, 85, 0.6);
  color: #94a3b8;
}
body.dark .rm-header .rm-close:hover {
  background: rgba(71, 85, 105, 0.8);
  color: #f1f5f9;
}

.rm-stats {
  display: flex;
  gap: 10px;
  padding: 0 24px 14px;
  flex-shrink: 0;
}

.rm-stat {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
}
.rm-stat ion-icon {
  font-size: 16px;
}
.rm-stat.rm-stat--read {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}
body.dark .rm-stat.rm-stat--read {
  background: rgba(34, 197, 94, 0.15);
}
.rm-stat.rm-stat--unread {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}
body.dark .rm-stat.rm-stat--unread {
  background: rgba(245, 158, 11, 0.15);
}
.rm-stat .rm-stat-num {
  font-size: 16px;
  font-weight: 800;
}
.rm-stat .rm-stat-label {
  font-weight: 500;
  opacity: 0.8;
}

.rm-segment {
  display: flex;
  gap: 4px;
  padding: 0 24px 12px;
  flex-shrink: 0;
}
.rm-segment .rm-seg-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 14px;
  border: 2px solid rgba(226, 232, 240, 0.8);
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.rm-segment .rm-seg-btn ion-icon {
  font-size: 15px;
}
.rm-segment .rm-seg-btn.active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(79, 70, 229, 0.05) 100%);
  border-color: #6366f1;
  color: #6366f1;
}
.rm-segment .rm-seg-btn:hover:not(.active) {
  border-color: #cbd5e1;
}
body.dark .rm-segment .rm-seg-btn {
  border-color: rgba(255, 255, 255, 0.12);
  color: #94a3b8;
}
body.dark .rm-segment .rm-seg-btn.active {
  border-color: #818cf8;
  color: #818cf8;
  background: rgba(99, 102, 241, 0.1);
}
body.dark .rm-segment .rm-seg-btn:hover:not(.active) {
  border-color: rgba(255, 255, 255, 0.2);
}

.rm-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 24px 12px;
  padding: 9px 14px;
  border-radius: 10px;
  border: 2px solid rgba(226, 232, 240, 0.8);
  background: rgba(241, 245, 249, 0.5);
  transition: border-color 0.2s ease;
  flex-shrink: 0;
}
.rm-search:focus-within {
  border-color: #6366f1;
}
.rm-search .rm-search-icon {
  color: #94a3b8;
  font-size: 17px;
  flex-shrink: 0;
}
.rm-search .rm-search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-text-color);
  font-family: inherit;
}
.rm-search .rm-search-input::placeholder {
  color: #94a3b8;
}
body.dark .rm-search {
  background: rgba(51, 65, 85, 0.4);
  border-color: rgba(255, 255, 255, 0.12);
}
body.dark .rm-search:focus-within {
  border-color: #818cf8;
}

.rm-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 20px;
  min-height: 200px;
}
.rm-scroll::-webkit-scrollbar {
  width: 5px;
}
.rm-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.rm-scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.3);
  border-radius: 4px;
}

.rm-loading {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}
.rm-loading ion-spinner {
  color: #6366f1;
  width: 28px;
  height: 28px;
}

.rm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 0;
  color: #94a3b8;
}
.rm-empty ion-icon {
  font-size: 36px;
  opacity: 0.5;
}
.rm-empty p {
  margin: 0;
  font-size: 14px;
}

.rm-user-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  transition: background 0.15s ease;
}
.rm-user-row:hover {
  background: rgba(241, 245, 249, 0.6);
}
body.dark .rm-user-row:hover {
  background: rgba(51, 65, 85, 0.3);
}
.rm-user-row + .rm-user-row {
  border-top: 1px solid rgba(226, 232, 240, 0.4);
}
body.dark .rm-user-row + .rm-user-row {
  border-color: rgba(255, 255, 255, 0.06);
}

.rm-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(16, 185, 129, 0.1) 100%);
  color: #22c55e;
  font-size: 12px;
  font-weight: 800;
  flex-shrink: 0;
  letter-spacing: 0.5px;
}
.rm-avatar.rm-avatar--pending {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(234, 88, 12, 0.1) 100%);
  color: #f59e0b;
}

.rm-user-info {
  flex: 1;
  min-width: 0;
}
.rm-user-info .rm-user-name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
body.dark .rm-user-info .rm-user-name {
  color: #f1f5f9;
}
.rm-user-info .rm-user-branch {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 1px;
}

.rm-read-time {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  flex-shrink: 0;
}
body.dark .rm-read-time {
  color: #94a3b8;
}

.rm-pending-badge {
  font-size: 11px;
  font-weight: 600;
  color: #f59e0b;
  padding: 3px 8px;
  border-radius: 6px;
  background: rgba(245, 158, 11, 0.1);
  flex-shrink: 0;
}

@media (max-width: 576px) {
  .rm-header {
    padding: 16px 16px 10px;
  }
  .rm-stats {
    padding: 0 16px 10px;
  }
  .rm-segment {
    padding: 0 16px 10px;
  }
  .rm-search {
    margin: 0 16px 10px;
  }
  .rm-scroll {
    padding: 0 16px 16px;
  }
  .rm-subtitle {
    max-width: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/readers-modal/readers-modal.component.scss"],"names":[],"mappings":"AASA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,WAAA;EACA,yEAAA;EACA,cAAA;AARF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;AATF;AAWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6FAAA;EACA,cAzCK;EA0CL,eAAA;EACA,cAAA;AAVJ;AAaE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXJ;AAYI;EAAc,cAAA;AATlB;AAYE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAVJ;AAWI;EAAc,cAAA;AARlB;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;AATJ;AAWI;EAAU,oCAAA;EAAsC,cAAA;AAPpD;AAQI;EACE,iCAAA;EAAmC,cAAA;AALzC;AAMM;EAAU,kCAAA;EAAoC,cAAA;AAFpD;;AAQA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AALF;AAOE;EAAW,eAAA;AAJb;AAME;EACE,kCAAA;EACA,cA3GI;AAuGR;AAKI;EAAc,mCAAA;AAFlB;AAKE;EACE,mCAAA;EACA,cAhHI;AA6GR;AAII;EAAc,oCAAA;AADlB;AAIE;EAAe,eAAA;EAAiB,gBAAA;AAAlC;AACE;EAAiB,gBAAA;EAAkB,YAAA;AAGrC;;AACA;EACE,aAAA;EACA,QAAA;EACA,oBAAA;EACA,cAAA;AAEF;AAAE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAEJ;AAAI;EAAW,eAAA;AAGf;AADI;EACE,8FAAA;EACA,qBAvJG;EAwJH,cAxJG;AA2JT;AAAI;EAAuB,qBAAA;AAG3B;AADI;EACE,uCAAA;EACA,cAAA;AAGN;AAFM;EAAW,qBA/JF;EA+J+B,cA/J/B;EA+JqD,mCAAA;AAOpE;AANM;EAAuB,sCAAA;AAS7B;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,kCAAA;EACA,cAAA;AAMF;AAJE;EAAiB,qBAnLV;AA0LT;AALE;EAAkB,cAAA;EAAgB,eAAA;EAAiB,cAAA;AAUrD;AARE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;AAUJ;AATI;EAAiB,cAAA;AAYrB;AATE;EACE,iCAAA;EACA,uCAAA;AAWJ;AAVI;EAAiB,qBArMN;AAkNf;;AARA;EACE,OAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAWF;AATE;EAAuB,UAAA;AAYzB;AAXE;EAA6B,uBAAA;AAc/B;AAbE;EAA6B,oCAAA;EAAsC,kBAAA;AAiBrE;;AAdA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAiBF;AAhBE;EAAc,cA1NP;EA0NuB,WAAA;EAAa,YAAA;AAqB7C;;AAlBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAqBF;AAnBE;EAAW,eAAA;EAAiB,YAAA;AAuB9B;AAtBE;EAAI,SAAA;EAAW,eAAA;AA0BjB;;AAtBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;AAyBF;AAvBE;EAAU,oCAAA;AA0BZ;AAzBE;EAAoB,iCAAA;AA4BtB;AA1BE;EAAmB,8CAAA;AA6BrB;AA7BqE;EAAc,uCAAA;AAgCnF;;AA7BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6FAAA;EACA,cA9PM;EA+PN,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAgCF;AA9BE;EACE,6FAAA;EACA,cArQI;AAqSR;;AA5BA;EACE,OAAA;EACA,YAAA;AA+BF;AA7BE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA+BJ;AA9BI;EAAc,cAAA;AAiClB;AA9BE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAgCJ;;AA5BA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AA+BF;AA9BE;EAAc,cAAA;AAiChB;;AA9BA;EACE,eAAA;EACA,gBAAA;EACA,cA3SM;EA4SN,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;AAiCF;;AA7BA;EACE;IAAa,uBAAA;EAiCb;EAhCA;IAAY,oBAAA;EAmCZ;EAlCA;IAAc,oBAAA;EAqCd;EApCA;IAAa,mBAAA;EAuCb;EAtCA;IAAa,oBAAA;EAyCb;EAxCA;IAAe,gBAAA;EA2Cf;AACF","sourcesContent":["// ============================================================\n// Readers Modal - Premium Glass Design\n// ============================================================\n\n$accent: #6366f1;\n$accent-light: #818cf8;\n$green: #22c55e;\n$amber: #f59e0b;\n\n.rm {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  overflow: hidden;\n}\n\n.rm-accent-bar {\n  height: 4px;\n  background: linear-gradient(90deg, $accent 0%, #4f46e5 50%, $accent-light 100%);\n  flex-shrink: 0;\n}\n\n// ---- Header ----\n.rm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 14px;\n  flex-shrink: 0;\n\n  .rm-header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  .rm-icon-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 14px;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(79, 70, 229, 0.1) 100%);\n    color: $accent;\n    font-size: 22px;\n    flex-shrink: 0;\n  }\n\n  .rm-title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    color: #1e293b;\n    body.dark & { color: #f1f5f9; }\n  }\n\n  .rm-subtitle {\n    margin: 2px 0 0;\n    font-size: 13px;\n    color: #64748b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 300px;\n    body.dark & { color: #94a3b8; }\n  }\n\n  .rm-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: rgba(241, 245, 249, 0.8);\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-size: 18px;\n    flex-shrink: 0;\n\n    &:hover { background: rgba(226, 232, 240, 0.8); color: #1e293b; }\n    body.dark & {\n      background: rgba(51, 65, 85, 0.6); color: #94a3b8;\n      &:hover { background: rgba(71, 85, 105, 0.8); color: #f1f5f9; }\n    }\n  }\n}\n\n// ---- Stats ----\n.rm-stats {\n  display: flex;\n  gap: 10px;\n  padding: 0 24px 14px;\n  flex-shrink: 0;\n}\n\n.rm-stat {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n\n  ion-icon { font-size: 16px; }\n\n  &.rm-stat--read {\n    background: rgba(34, 197, 94, 0.1);\n    color: $green;\n    body.dark & { background: rgba(34, 197, 94, 0.15); }\n  }\n\n  &.rm-stat--unread {\n    background: rgba(245, 158, 11, 0.1);\n    color: $amber;\n    body.dark & { background: rgba(245, 158, 11, 0.15); }\n  }\n\n  .rm-stat-num { font-size: 16px; font-weight: 800; }\n  .rm-stat-label { font-weight: 500; opacity: 0.8; }\n}\n\n// ---- Segment ----\n.rm-segment {\n  display: flex;\n  gap: 4px;\n  padding: 0 24px 12px;\n  flex-shrink: 0;\n\n  .rm-seg-btn {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 9px 14px;\n    border: 2px solid rgba(226, 232, 240, 0.8);\n    border-radius: 10px;\n    background: transparent;\n    color: #64748b;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-family: inherit;\n\n    ion-icon { font-size: 15px; }\n\n    &.active {\n      background: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(79, 70, 229, 0.05) 100%);\n      border-color: $accent;\n      color: $accent;\n    }\n\n    &:hover:not(.active) { border-color: #cbd5e1; }\n\n    body.dark & {\n      border-color: rgba(255, 255, 255, 0.12);\n      color: #94a3b8;\n      &.active { border-color: $accent-light; color: $accent-light; background: rgba(99, 102, 241, 0.1); }\n      &:hover:not(.active) { border-color: rgba(255, 255, 255, 0.2); }\n    }\n  }\n}\n\n// ---- Search ----\n.rm-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 24px 12px;\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 2px solid rgba(226, 232, 240, 0.8);\n  background: rgba(241, 245, 249, 0.5);\n  transition: border-color 0.2s ease;\n  flex-shrink: 0;\n\n  &:focus-within { border-color: $accent; }\n\n  .rm-search-icon { color: #94a3b8; font-size: 17px; flex-shrink: 0; }\n\n  .rm-search-input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-text-color);\n    font-family: inherit;\n    &::placeholder { color: #94a3b8; }\n  }\n\n  body.dark & {\n    background: rgba(51, 65, 85, 0.4);\n    border-color: rgba(255, 255, 255, 0.12);\n    &:focus-within { border-color: $accent-light; }\n  }\n}\n\n// ---- Scroll Content ----\n.rm-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 24px 20px;\n  min-height: 200px;\n\n  &::-webkit-scrollbar { width: 5px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n  &::-webkit-scrollbar-thumb { background: rgba(148, 163, 184, 0.3); border-radius: 4px; }\n}\n\n.rm-loading {\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n  ion-spinner { color: $accent; width: 28px; height: 28px; }\n}\n\n.rm-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 40px 0;\n  color: #94a3b8;\n\n  ion-icon { font-size: 36px; opacity: 0.5; }\n  p { margin: 0; font-size: 14px; }\n}\n\n// ---- User Row ----\n.rm-user-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  transition: background 0.15s ease;\n\n  &:hover { background: rgba(241, 245, 249, 0.6); }\n  body.dark &:hover { background: rgba(51, 65, 85, 0.3); }\n\n  & + .rm-user-row { border-top: 1px solid rgba(226, 232, 240, 0.4); body.dark & { border-color: rgba(255, 255, 255, 0.06); } }\n}\n\n.rm-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(16, 185, 129, 0.1) 100%);\n  color: $green;\n  font-size: 12px;\n  font-weight: 800;\n  flex-shrink: 0;\n  letter-spacing: 0.5px;\n\n  &.rm-avatar--pending {\n    background: linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(234, 88, 12, 0.1) 100%);\n    color: $amber;\n  }\n}\n\n.rm-user-info {\n  flex: 1;\n  min-width: 0;\n\n  .rm-user-name {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #1e293b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    body.dark & { color: #f1f5f9; }\n  }\n\n  .rm-user-branch {\n    display: block;\n    font-size: 11px;\n    color: #94a3b8;\n    margin-top: 1px;\n  }\n}\n\n.rm-read-time {\n  font-size: 11px;\n  color: #64748b;\n  white-space: nowrap;\n  flex-shrink: 0;\n  body.dark & { color: #94a3b8; }\n}\n\n.rm-pending-badge {\n  font-size: 11px;\n  font-weight: 600;\n  color: $amber;\n  padding: 3px 8px;\n  border-radius: 6px;\n  background: rgba(245, 158, 11, 0.1);\n  flex-shrink: 0;\n}\n\n// ---- Responsive ----\n@media (max-width: 576px) {\n  .rm-header { padding: 16px 16px 10px; }\n  .rm-stats { padding: 0 16px 10px; }\n  .rm-segment { padding: 0 16px 10px; }\n  .rm-search { margin: 0 16px 10px; }\n  .rm-scroll { padding: 0 16px 16px; }\n  .rm-subtitle { max-width: 180px; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
